import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/8876c15/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/modal--default",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-modal--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvmodal--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=modal"
    }} knobs={{
      ModalWrapper: ["passiveModal", "danger", "disabled", "hasScrollingContent", "size"]
    }} mdxType="ComponentDemo">
  {`
<ModalWrapper
  buttonTriggerText="Launch modal"
  modalHeading="Modal heading"
  modalLabel="Label"
>
  <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse cursus fermentum risus, sit amet fringilla nunc pellentesque quis. Duis quis odio ultrices, cursus lacus ac, posuere felis. Donec dignissim libero in augue mattis, a molestie metus vestibulum. Aliquam placerat felis ultrices lorem condimentum, nec ullamcorper felis porttitor. </p>
</ModalWrapper>
`}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      